export default __webpack_public_path__ + "static/media/add_missed_punchin.1877f5de.svg";